import { describe, it, expect } from 'vitest';

describe('@memberjunction/ng-query-viewer', () => {
  it('should have a passing test', () => {
    expect(true).toBe(true);
  });
});
